import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Modal } from 'antd';

import { twisterType as type } from 'app/constants/twisterType.constants';

import {
  setTourAmount,
  setTwisterData,
} from 'app/actions/FullTour/full_tour_view.action';
import { cleanTourPart } from 'actions/Map/tour.full.data.action';

import withTranslations from 'app/components/HOGs/withTranslations';
import { emptyTourModel } from '../Models/tour.model';

import { userInfoForTour } from '../extraFuncs';

import RideTwisterSwitcher from './components/Switcher';

import ToPoint from './modes/ToPoint';
import RoundTrip from './modes/RoundTrip';
import FreeHand from './modes/FreeHand';

import './RideTwister.css';
import { RTService } from './RideTwister.service';

const { confirm } = Modal;

let init = true;
let compassTO = null;
const RideTwister = (props) => {
  const { tr, fullScreenMode } = props;
  const { checkIfStartPointSetAutomatic } = RTService;
  const dispatch = useDispatch();

  const [loadingRecalculate, setLoadingRecalculate] = useState(false);
  const [loading, setLoading] = useState(false);

  const edit = useSelector((state) => state.tourFullData.isEditMode);
  const activeTourTab = useSelector(
    (state) => state.tourFullData.activeTourTab
  );

  const multiDay = useSelector((store) => store.tourFullData.data.multiDay);
  const id = useSelector((state) => state.tourFullData.data.id);
  // const points = useSelector((state) => state.tourFullData.data.points);
  const parts = useSelector((state) => state.tourFullData.data.parts);
  const activeMultiPart = useSelector(
    (state) => state.tourFullData.activeMultiPart
  );
  const isClearTour = useSelector((state) => state.tourFullData.isClearTour);
  const user = useSelector((store) => store.authentication.user);

  const { twister_data = {}, points, pointsData } = activeMultiPart;
  const { direction, is_random, slider, twister_type } = twister_data;
  const [activeSetting, setActiveSetting] = useState(slider || 0);

  const recalculate = () => {
    init = false;
    setLoadingRecalculate(!loadingRecalculate);
    setLoading(true);
  };

  useEffect(() => {
    if (!edit) {
      init = true;
    }
  }, [edit]);

  useEffect(() => {
    init = true;
  }, [activeMultiPart]);

  useEffect(() => {
    return () => {
      init = true;
    };
  }, []);

  const setSliderValue = (val) => {
    init = false;
    dispatch(
      setTwisterData({
        slider: val,
      })
    );
  };

  const setCompassRotate = (val) => {
    init = false;
    if (compassTO) {
      clearTimeout(compassTO);
    }
    compassTO = setTimeout(() => {
      dispatch(
        setTwisterData({
          direction: val,
        })
      );
    }, 500);
  };

  const changeIsSetRotate = (val) => {
    init = false;
    dispatch(
      setTwisterData({
        is_random: !val,
      })
    );
  };

  const reset = () => {
    dispatch(
      setTwisterData({
        direction: 0,
        slider: 0,
        speed_profile: 0,
        is_random: true,
      })
    );
  };

  const isEmptyPart = () => {
    let isEmpty = true;

    points.forEach((point) => {
      if (!point.isEmpty) {
        isEmpty = false;
      }
    });

    return isEmpty;
  };

  const setData = (scope) => {
    setActiveSetting(0);
    dispatch(setTwisterData({ twister_type: scope }));
  };

  const setTourData = (scope) => {
    setActiveSetting(0);
    dispatch(
      cleanTourPart({
        ...emptyTourModel(userInfoForTour(user)),
        id,
        twister_data: {
          direction: 0,
          is_random: true,
          slider: 0,
          speed_profile: 0,
          twister_type: scope,
        },
      })
    );
    dispatch(setTourAmount(true));
    dispatch(setTwisterData({ twister_type: scope }));
  };

  const changeScope = (scope) => {
    init = true;
    const getTitle = () =>
      +activeTourTab === 0
        ? tr[
            'Your current tour will be cleared if you continue. Do you want to continue?'
          ]
        : tr[
            'Your current part will be cleared if you continue. Do you want to continue?'
          ];
    if (
      !isEmptyPart() &&
      !checkIfStartPointSetAutomatic(parts, activeTourTab)
    ) {
      confirm({
        title: getTitle(),
        okText: tr.Yes,
        okType: 'danger',
        cancelText: tr.No,
        onOk() {
          setTourData(scope);
        },
        onCancel() {
          return null;
        },
      });
    } else if (checkIfStartPointSetAutomatic(parts, activeTourTab)) {
      setData(scope);
    } else {
      setTourData(scope);
    }
  };

  const getClass = () =>
    twister_type === type.RidePlan
      ? 'rideTwisterLayout ridePlan'
      : 'rideTwisterLayout';

  const getStyle = {
    position: 'absolute',
    top: 60,
    right: 20,
    zIndex: 99999,
  };

  return !multiDay || (multiDay && +activeTourTab !== 0) ? (
    <div className={getClass()} style={fullScreenMode ? getStyle : {}}>
      <RideTwisterSwitcher setScope={changeScope} scope={twister_type} />
      {twister_type === type.ToPoint ? (
        <ToPoint
          sliderValue={slider}
          compassRotate={direction}
          isSetRotate={!is_random}
          setSliderValue={setSliderValue}
          recalculate={recalculate}
          loadingRecalculate={loadingRecalculate}
          isClearTour={isClearTour}
          activeMultiPart={activeMultiPart}
          loading={loading}
          setLoading={setLoading}
          setActiveSetting={setActiveSetting}
          activeSetting={activeSetting}
          points={points}
          init={init}
          edit={edit}
          pointsData={pointsData}
        />
      ) : null}
      {twister_type === type.RoundTrip ? (
        <RoundTrip
          sliderValue={slider}
          setSliderValue={setSliderValue}
          recalculate={recalculate}
          loadingRecalculate={loadingRecalculate}
          compassRotate={direction}
          setCompassRotate={setCompassRotate}
          isSetRotate={!is_random}
          changeIsSetRotate={changeIsSetRotate}
          reset={reset}
          isClearTour={isClearTour}
          loading={loading}
          setLoading={setLoading}
          activeMultiPart={activeMultiPart}
          setActiveSetting={setActiveSetting}
          activeSetting={activeSetting}
          points={points}
          init={init}
          edit={edit}
          pointsData={pointsData}
        />
      ) : null}
      {twister_type === type.FreeHand ? (
        <FreeHand isEmptyPart={isEmptyPart} />
      ) : null}
    </div>
  ) : null;
};

export default withTranslations(RideTwister);
